import { useTranslation } from 'react-i18next';
import Stat from './stat';
import { Col } from 'react-bootstrap';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';

function ReturnsStat({ data, previousData }) {
  const { t } = useTranslation();

  const isNoPeriodData = useSelector(
    (state) => state.meTicketData.isNoPeriodData
  );

  const percent = useMemo(() => {
    const previousValue = previousData?.ticketReturnsAmountByPeriod;
    if (!previousValue) return null;
    return parseInt(
      ((data.ticketReturnsAmountByPeriod - previousValue) / previousValue) * 100
    );
  }, [data.ticketReturnsAmountByPeriod, previousData]);
  return (
    <Col
      className={classNames('col-md-6 mt-0', {
        'opacity-25': isNoPeriodData
      })}
    >
      <Stat
        icon={'arrow-counterclockwise'}
        mainLabel={t('ticketStatistic.ticketReturns')}
        smallLabel={t('ticketStatistic.ticketReturnsDescription')}
        value={data.ticketReturnsAmount}
        percentage={percent}
        dataByPeriod={data.ticketReturnsAmountByPeriod}
        col={'Returns'}
      />
    </Col>
  );
}

export default ReturnsStat
